import React from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";
import { GetBeforeAndAfterHitRanges } from "../../Calculators/RangeSplitter";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../Helpers/RgbColorHelper";

export default function Summary_2_Right({ item, isSub }) {
  //const isHtml = item.scale.isHtml;
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Detect if RGB color system is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper
  const colors = getScaleColors(item.scale);
  let splitRanges = GetBeforeAndAfterHitRanges(item?.scale.ranges);
  const filledPart =
    ((elementScore - splitRanges.hitRange?.start) / (splitRanges.hitRange?.end - splitRanges.hitRange?.start)) * 100;

  return (
    <Row className={"mb-2 mx-0"}>
      <Col className={"align-content-center"} xs={4}>
        <Row className={isSub ? "sub-name-style-wrap-up-thin" : "name-style-wrap-up-thin"}>
          <Col className={"align-content-center text-end"}>
            <span
              style={rgbEnabled ? { color: !isSub ? colors.dark : colors.primary, fontWeight: "bold" } : {}}
              className={!rgbEnabled ? (!isSub ? "main-scope-name-color-wrap-up" : "sub-scope-name-color-wrap-up") : ""}
            >
              {item.name}
            </span>
          </Col>
          <Col xs={"auto"} className={"align-content-center px-0"}>
            <Row className={"justify-content-center mx-0"}>
              <div
                className={"_flex-center " + (isSub ? "sub-score-style-wrap-up-thin" : "score-style-wrap-up-thin")}
                style={
                  rgbEnabled
                    ? {
                        width: "82px",
                        backgroundColor: colors.primary,
                        color: "#ffffff",
                        border: `2px solid ${colors.dark}`,
                      }
                    : { width: "82px" }
                }
              >
                {elementScore} {isSub ? "%" : ""}
              </div>
            </Row>
          </Col>
        </Row>
      </Col>

      <Col xs={8} className={"align-content-center"}>
        <Row>
          {splitRanges.beforeHitRangeList.map((range, i) => {
            return (
              <Col key={"before" + i} className="px-0 align-content-center">
                <ProgressBar
                  className={isSub ? "sub-scale-style-thin" : "scale-style-thin"}
                  style={{ height: "12px", margin: "0 1px" }}
                  now={100}
                ></ProgressBar>
              </Col>
            );
          })}
          <Col className="p-0 align-content-center">
            <ProgressBar
              className={isSub ? "sub-scale-style-thin" : "scale-style-thin"}
              style={{ height: "12px", margin: "0 1px" }}
              now={filledPart}
            ></ProgressBar>
          </Col>
          {splitRanges.afterHitRangeList.map((range, i) => {
            return (
              <Col key={"after" + i} className="px-0 align-content-center">
                <ProgressBar
                  className={isSub ? "sub-scale-style-thin" : "scale-style-thin"}
                  style={{ height: "12px", margin: "0 1px" }}
                  now={0}
                ></ProgressBar>
              </Col>
            );
          })}
        </Row>
      </Col>
    </Row>
  );
}
